import axios from 'axios';

export const GET_INVOICES_URL = '/invoices/getInvoices';
export const SEND_INVOICE_BY_MAIL = '/invoices/sendInvoiceByMail';
export const DOWNLOAD_INVOICE = '/invoices/downloadInvoicePDF';
export const DOWNLOAD_INVOICE_RECEIPTS = '/invoices/downloadInvoiceReceiptsPDFs';
export const SEND_INVOICE_REMINDER = '/invoices/sendInvoiceReminder';
export const ADD_RECEIPT_TO_INVOICE = '/invoices/addReceiptToInvoice';
export const GET_INVOICES_EXCEL = '/invoices/getInvoicesForExcel';
export const REOPEN_INVOICE = '/invoices/reopenInvoice';
export const CANCEL_INVOICE = '/invoices/cancelInvoice';
export const CONVERT_INVOICE_TO_TYPE_1 = '/invoices/convertToInvoiceTypeOne';
export const CONVERT_INVOICE_TO_TYPE_2 = '/invoices/convertToInvoiceTypeTwo';
export const GET_INVOICE_TYPES = '/invoices/getInvoiceTypes';

export function findInvoices(queryParams, cancellationHandlers) {
  return axios.get(GET_INVOICES_URL, {params: queryParams, ...cancellationHandlers});
}

export function sendInvoicesByEmail({invoiceTypeID, invoiceNum, emailAddress}) {
  return axios.post(SEND_INVOICE_BY_MAIL, {invoiceTypeID, invoiceNum, emailAddress});
}

export function downloadInvoice({invoiceTypeID, invoiceNum}) {
  return axios.post(DOWNLOAD_INVOICE, {invoiceTypeID, invoiceNum});
}

export function downloadInvoiceReceipts({invoiceID, receiptArray}) {
  return axios.post(DOWNLOAD_INVOICE_RECEIPTS, {invoiceID, receiptArray});
}

export function sendInvoiceReminder({
                                      invoiceID,
                                      sendToAgent,
                                      sendToCustomer,
                                      sendByMail,
                                      sendBySMS,
                                      sendByWhatsapp,
                                    }) {

  return axios.post(SEND_INVOICE_REMINDER, {
      invoiceID,
      sendToAgent,
      sendToCustomer,
      sendByMail,
      sendBySMS,
      sendByWhatsapp,
    }
  );
}

export function addReceiptToInvoice({invoiceID, receiptID}) {
  return axios.post(ADD_RECEIPT_TO_INVOICE, {invoiceID, receiptID});
}

export function getInvoicesFile(queryParams) {
  return axios.get(GET_INVOICES_EXCEL, {params: queryParams});
}

export function reopenInvoice(invoiceID) {
  return axios.post(REOPEN_INVOICE, {invoiceID});
}

export function cancelInvoice(invoiceID, comments, customerEmail) {
  return axios.post(CANCEL_INVOICE, {invoiceID, comments, customerEmail});
}

export function convertInvoiceToType1(invoiceID) {
  return axios.post(CONVERT_INVOICE_TO_TYPE_1, {invoiceID});
}

export function convertInvoiceToType2(data) {
  return axios.post(CONVERT_INVOICE_TO_TYPE_2, data);
}

export function getInvoiceTypes() {
  return axios.get(GET_INVOICE_TYPES);
}